import { addToRecord, objectWithoutKeys } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignGoalTrackerCreateFulfilledAction } from '../../domains/campaignGoalTracker/createActions.types';
import { CampaignGoalTrackerEditFulfilledAction } from '../../domains/campaignGoalTracker/editActions.types';
import { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';

import { CampaignGoalTrackerRecord } from './types';

export type CampaignGoalTrackerAction =
  | CampaignLoadFulfilledAction
  | CampaignGoalTrackerCreateFulfilledAction
  | CampaignGoalTrackerEditFulfilledAction;

const initialState: CampaignGoalTrackerRecord = {};

type AddToRecordIfGoalTrackerExists = (
  state: CampaignGoalTrackerRecord,
  { id, entities }: CampaignGoalTrackerAction['payload']
) => CampaignGoalTrackerRecord;
const updateGoalTrackerRecord: AddToRecordIfGoalTrackerExists = (state, { id, entities }) => {
  if (entities.campaignGoalTracker[id].goalTracker) {
    return addToRecord(state, id, entities.campaignGoalTracker[id]);
  }

  return objectWithoutKeys(state, [id]);
};

const reducer: Reducer<CampaignGoalTrackerRecord, CampaignGoalTrackerAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.LOAD_FULFILLED':
      return updateGoalTrackerRecord(state, action.payload);
    case 'CAMPAIGN.GOALTRACKER.CREATE_FULFILLED':
      return updateGoalTrackerRecord(state, action.payload);
    case 'CAMPAIGN.GOALTRACKER.EDIT_FULFILLED':
      return updateGoalTrackerRecord(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
